import React, { createContext, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useContent } from '../hooks/customHooks';
import routeHelper from '../helpers/routeHelper';
import { ErrorStatusTypes } from '../constants/ErrorStatusTypes';

export const LocationContext = createContext(null);

const LocationContextProvider = ({ children }) => {
    const { content } = useContent();
    const navigate = useNavigate();
    const [locationContext, setLocationContext] = useState({
        nearbyLocations: null,
        selectedLocation: null,
        userLocation: null,
        byUser: false,
        askForLocation: false,
        locationDenied: false,
    });

    const updateLocationContext = data => {
        setLocationContext(prevState => ({
            ...prevState,
            ...data,
        }));
    };

    const getMyLocation = () => {
        window.navigator.geolocation.getCurrentPosition(
            geo => {
                setLocationContext(prevState => ({
                    ...prevState,
                    byUser: true,
                    locationDenied: false,
                    userLocation: { lat: geo.coords.latitude, lng: geo.coords.longitude },
                }));
            },
            err => {
                if (err.code === err.PERMISSION_DENIED) {
                    setLocationContext(prevState => ({ ...prevState, locationDenied: true }));
                    routeHelper(ErrorStatusTypes.NO_LOCATION, content, navigate);
                }
            },
            { enableHighAccuracy: true, maximumAge: 0 }
        );
    };

    useEffect(() => {
        locationContext.askForLocation && getMyLocation();
    }, [locationContext.askForLocation]);

    return (
        <LocationContext.Provider
            value={{ ...locationContext, getMyLocation, updateLocationContext }}
        >
            {children}
        </LocationContext.Provider>
    );
};

export default LocationContextProvider;
